import { useMutation } from '@tanstack/react-query'
import { apiClient } from '@/lib/api-client'

interface InviteCodeResponse {
  code: string
  inviteLink: string
  expiresAt: string
}

export function useGenerateInvite() {
  return useMutation({
    mutationFn: () => apiClient.post<InviteCodeResponse>('/api/v1/households/invite', {}),
  })
}
